import * as React from 'react';

import { Slot } from '@radix-ui/react-slot';
import { type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

import { SimpleSpinner } from '@/components/common';

import { buttonVariants } from './buttonVariants';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
  rightElement?: React.ReactNode;
  leftElement?: React.ReactNode;
  isLoading?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      variant,
      size,
      asChild = false,
      children,
      rightElement,
      leftElement,
      isLoading,
      ...props
    },
    ref
  ) => {
    const Comp = asChild ? Slot : 'button';

    return (
      <Comp
        className={cn(
          buttonVariants({ variant, size, className }),
          'cursor-pointer'
        )}
        ref={ref}
        disabled={!!isLoading}
        {...props}
      >
        <div className='relative flex gap-2 items-center justify-between '>
          {isLoading && <SimpleSpinner noBackground={true} />}
          {leftElement && (
            <div className='absolute top-1/2 -translate-y-1/2 -left-8'>
              {leftElement}
            </div>
          )}
          {children}
          {rightElement && (
            <div className='absolute top-1/2 -translate-y-1/2 -right-8'>
              {rightElement}
            </div>
          )}
        </div>
      </Comp>
    );
  }
);
Button.displayName = 'Button';

export { Button };
